// extracted by mini-css-extract-plugin
export default {"Search":"Search_Search__q5aJn","Form":"Search_Form__anNwK","SearchResults":"Search_SearchResults__6BDkz","Open":"Search_Open__EDjCQ","ShowAdditional":"Search_ShowAdditional__TnYnp"};